import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const tokens = combineTokens("--in-table-text", {
  maxWidth: units.px(250)
});
const wrapper = "_35swb61ng1";

export { tokens, wrapper };
import "./input.text.style.linaria.module.css";
//# sourceMappingURL=input.text.style.js.map
